import "./Donate.module.css";
import Header from "@/reusable_sections/Header";
import CampusVisitInvitation from "./sections/CampusVisitInvitation";
import ContactMessageSection from "./sections/ContactMessageSection";
import YeFooter from "@/reusable_sections/Footer";
export default function DonatePage() {
  return <div>
      <Header />
      <CampusVisitInvitation />
      <ContactMessageSection />
      <YeFooter />
    </div>;
}